'use client'

import React from 'react'
import * as Select from '@radix-ui/react-select'

import { cn } from '../../utils/cn'

interface SelectItemProps extends React.HTMLAttributes<HTMLDivElement> {
  value: string
}

const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <Select.Item
        className={cn(
          className,
          'focus:bg-primary-500 px-1 py-2 hover:bg-neutral-100 focus:rounded-md focus:text-white focus:outline-none truncate'
        )}
        {...props}
        ref={forwardedRef}
        value={props.value}
      >
        <Select.ItemText>{children}</Select.ItemText>
      </Select.Item>
    )
  }
)

SelectItem.displayName = 'SelectItem'

export { SelectItem }
